import { makeStyles } from 'tss-react/mui'
import { keyframes } from 'tss-react'

const textareaAppear = keyframes`
  from {
    opacity: 0,
    transform: translateY(-12px),
  }
  to {
    opacity: 1,
    transform: translateY(0),
  }
`

export default makeStyles()(theme => ({
  container: {
    textAlign: 'center',
    color: theme.palette.text.secondary,
    lineHeight: '1.5em',
    position: 'relative',
  },
  text: {
    display: 'inline-block',
    animation: 'text-introduction-appear 1s ease',
    animationDelay: '0.4s',
    animationFillMode: 'backwards',
    margin: `0 ${theme.spacing(-1)} auto`,
    position: 'relative',
    width: 'auto',
    [theme.breakpoints.down('sm')]: {
      textAlign: 'justify',
      paddingLeft: '0 !important',
    },
  },
  placeholder: {
    color: 'rgba(0, 0, 0, 0.65)',
  },
  error: {
    color: 'rgb(244, 67, 54)',
    marginLeft: theme.spacing(1),
  },
  edit: {
    position: 'absolute',
    right: -24,
    top: 'calc(50% - 24px)',
  },
  textarea: {
    animation: `${textareaAppear} 0.2s ease-out 0.2s backwards`,
  },
  textareaWrapper: {
    overflow: 'hidden',
  },
}))
